module.exports = __webpack_public_path__ + "img/Uncheck.56b28761.svg";